import { CampaignTemplates, } from "@kvix/shared";
import { useOnce } from "@react-spring/shared";
import React, { createContext, useCallback, useState } from "react";
import { useLocalStorage } from "react-use";
export const AdminCampaignContentContext = createContext(null);
export const AdminCampaignContentContextProvider = (props) => {
    const [currentContent, setCurrentContent] = useState();
    const [availableTemplates, setAvailableTemplates] = useState([]);
    const [testInstructor, setTestInstructor] = useState();
    const [instructors, setInstructors] = useState();
    const [sessions, setSessions] = useState();
    const [answers, setAnswers] = useState();
    const [canSave, setCanSave] = useState(false);
    const [canSaveDraft, setCanSaveDraft] = useState(false);
    const [campaignAutosave, setCampaignAutosave] = useLocalStorage("campaignContentAutosave", currentContent);
    useOnce(() => {
        const templates = Object.keys(CampaignTemplates)
            .filter((value) => {
            if (CampaignTemplates[value] !== CampaignTemplates.DefaultTemplate) {
                return value;
            }
        })
            .map((key) => {
            return CampaignTemplates[key];
        });
        setAvailableTemplates(templates);
    });
    const updateContent = useCallback((block) => {
        const tempBlocks = currentContent.data.blocks.map((b) => {
            if (b.name === block.name) {
                return block;
            }
            else
                return b;
        });
        const tempData = Object.assign(Object.assign({}, currentContent.data), { blocks: tempBlocks });
        setCurrentContent(Object.assign(Object.assign({}, currentContent), { data: tempData }));
    }, [currentContent]);
    return (React.createElement(AdminCampaignContentContext.Provider, { value: {
            currentContent,
            setCurrentContent,
            availableTemplates,
            updateContent,
            testInstructor,
            setTestInstructor,
            instructors,
            setInstructors,
            sessions,
            setSessions,
            answers,
            setAnswers,
            canSave,
            setCanSave,
            canSaveDraft,
            setCanSaveDraft,
            campaignAutosave,
            setCampaignAutosave,
        } }, props.children));
};
//# sourceMappingURL=adminCampaignContentContext.js.map